var projectForm = (function () {
  var currentProjectStatus = {
    message:
      "We know you love us, and that your friends will too. Do refer our program to other open-source contributors.",
    img: "paid-user",
    heading: "You're already on a BrowserStack plan!",
  },
    projectFormObj = {
      formContainer: document.querySelector(".open-source__container"),
      formObj: document.getElementById("open-source__form--project"),
      projectUrlField: document.getElementById("project_url"),
      submitBtn: document.getElementById("project_submit"),
    };
  
  return {
    init: init,
    setApplicationStatus: setApplicationStatus,
    saveProject: saveProject,
    loadingState: loadingState,
    onLoadStatus: true,
  };

  function init() {
    if (projectFormObj.formObj) {
      projectFormObj.formObj.addEventListener("submit", function (e) {
        e.preventDefault();

        WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
          form: "Project Link Form",
          action: "click",
          clicked_title: "submit",
        });

        loadingState();
        
        if (!validateFields()) {
          loadingState(true);
          return false;
        }
        var recaptchaElemt = document.querySelectorAll(".g-recaptcha");
        for (var i = 0; i < recaptchaElemt.length; i++) {
          recaptchaElemt[i].classList.remove("error");
          if (recaptchaElemt[i].querySelector("span")) {
            recaptchaElemt[i].querySelector("span").remove();
          }
        }

        if (typeof grecaptcha !== "undefined") {
          grecaptcha.execute();
        }

        return false;
      });

      if (wpUserLoggedIn) {
        if (signUpFormObj.formObj) {
          // Removing SignUp-SignIn Form
          signUpFormObj.formObj.remove();
        }

        var recaptchaElemt = document.querySelectorAll(".g-recaptcha");
        for (var i = 0; i < recaptchaElemt.length; i++) {
          recaptchaElemt[i].classList.remove("error");
          if (recaptchaElemt[i].querySelector("span")) {
            recaptchaElemt[i].querySelector("span").remove();
          }
        }

        if (typeof grecaptcha !== "undefined") {
          grecaptcha.execute();
        }
      } else {
        if (projectFormObj.formObj) {
          projectFormObj.formObj.remove();
        }
      }
      if (projectFormObj.formContainer) {
        projectFormObj.formContainer.classList.remove("loading");
      }
    }
  }

  function loadingState(loadedState, loadingText) {
    if (projectFormObj.formContainer) {
      projectFormObj.loadingContainer =
        projectFormObj.formContainer.querySelector(".loading-container");
    }

    if (projectFormObj.loadingContainer) {
      if (loadedState) {
        projectFormObj.loadingContainer.style.display = "none";
      } else {
        projectFormObj.loadingContainer.style.display = "block";
      }
    }
    if (projectFormObj.submitBtn) {
      if (loadedState) {
        projectFormObj.submitBtn.classList.remove("disabled");
        projectFormObj.submitBtn.value = loadingText ? loadingText : "Submit";
      } else {
        projectFormObj.submitBtn.classList.add("disabled");
        projectFormObj.submitBtn.value = loadingText
          ? loadingText
          : "Please wait...";
      }
    }
  }
  function setApplicationStatus() {
    var status = new Promise(function (resolve, reject) {
      if (grecaptcha === undefined) {
        reject("Invalid Recaptha");
      }
      
      var grecaptchaResponse = grecaptcha.getResponse();
      if (!grecaptchaResponse) {
        reject("Invalid Recaptha Response");
      }

      bsLib.ajax(
        "GET",
        railsHost + "/open_source_sponsorship/status?g-recaptcha-response=" + encodeURIComponent(grecaptchaResponse),
        {},
        true,
        {
          "content-type": "application/x-www-form-urlencoded; charset=utf-8"
        },
        // Success message for status call.
        function (data) {
          if (data.readyState === 4) {
            var res = bsLib.JSONParse(data.response);
            if (res.success && data.status === 200) {
              resolve(res); // Resolve with the response data
            }
          }
        },
        // Custom error message for status call.
        function (data) {
          if (data.readyState === 4) {
            var resError = bsLib.JSONParse(data.response);
            if (!resError.success) {
              new bsAlert({
                alertType: "error",
                timeout: false,
                text: resError["message"]
              });
            }
            reject(data); // Reject with the error data
          }
        }
      );
    });

    // Log when promise is resolved or rejected
    status
      .then(function (data) {
        // Handle successful response
        if (data && data.data && data.data.applied && data.data.status) {
          switch (data.data.status) {
            case "pending":
              currentProjectStatus = {
                message:
                  "Thank you for taking interest in Browserstack's Open Source Sponsorship Program! We will reach out to you soon!",
                img: "status-pending",
                heading: "Application Successful!",
              };

              saveProject(false);
              break;
            case "verified":
              currentProjectStatus = {
                message:
                  "You application for BrowserStack Open Source Program is approved. Thank you for being a part of BrowserStack Family",
                img: "status-verified",
                heading: "Congratulations",
              };
              saveProject(false);
              break;
            case "failed":
              aInt = setInterval(function () {
                if (typeof bsAlert !== undefined) {
                  new bsAlert({
                    alertType: "error",
                    text: data.message,
                  });
                  clearInterval(aInt);
                }

                aCount = 0;
                if (++aCount > 20) {
                  console.error(data.message);
                  clearInterval(aInt);
                }
              }, 100);
              break;
            default:
              break;
          }
        }
      })
      .catch(function (errorData) {
        var res = bsLib.JSONParse(errorData.response);

        if (
          errorData.status == 400 &&
          res.success == true &&
          res.data &&
          res.data.paid_user
        ) {
          saveProject(false);
        } else {
          bInt = setInterval(function () {
            if (typeof bsAlert !== undefined) {
              new bsAlert({
                alertType: "error",
                text: errorData.statusText,
                htmlMessage: true,
              });
              clearInterval(bInt);
            }
            bCount = 0;
            if (++bCount > 20) {
              clearInterval(bInt);
            }
          }, 100);
        }
      })
      .finally(function () {
        projectForm.onLoadStatus = false;
        if (typeof grecaptcha !== 'undefined' && document.querySelector("#open-source__form--project .g-recaptcha")) {
          grecaptcha.reset();
        }
        loadingState(true);
      });
  }

  function saveProject(isProjectForm) {
    if (null == projectFormObj.formObj) {
      return;
    }
    if (isProjectForm) {
      signUpForm.setCsrfToken(false);
      var action = "/open_source_sponsorship/project",
        form_data = {
          authenticity_token: csrf_token,
          page_url: currentPageUrl,
          previous_page_url: previousPageUrl,
        };
      var submitForm = new Promise(function (resolve, reject) {
        if (grecaptcha === undefined) {
          reject("Invalid Recaptha");
        }

        var grecaptchaResponse = grecaptcha.getResponse();
        if (!grecaptchaResponse) {
          reject("Invalid Recaptha Response");
        }
        form_data["g-recaptcha-response"] = grecaptchaResponse;
        form_data["project_url"] = projectFormObj.projectUrlField.value;
        // xhr request for sending form data
        bsLib.ajax(
          "POST",
          railsHost + action,
          JSON.stringify(form_data),
          false,
          //Form Header
          {
            "X-CSRF-Token": csrf_token,
            accept: "application/json",
            "content-type": "application/json; charset=utf-8", // Setting content type.
          },
          function (data) {
            //success
            var res = bsLib.JSONParse(data.response);
            if (res.data.status != "failed") {
              WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
                form: "Project Link Form",
                action: "submit",
                success: "true",
              });
              resolve(res); // Resolve with the response data
            } else {
              WebEventTracker.logEvent(EDS.webEvents, "OpenSourceForm", {
                form: "Project Link Form",
                action: "submit",
                success: "false",
              });
              new bsAlert({
                alertType: "error",
                timeout: false,
                text: res["message"]
              });
              reject(res);
            }
          },
          function (data) {
            reject(data);
          },
          true
        );
      });

      submitForm
        .then(function (data) {
          window.location.reload(); // Reload on project submited
        })
        .catch(function (errorData) {
          new bsAlert({
            alertType: "error",
            text: errorData.message,
            htmlMessage: true,
          });
        })
        .finally(function () {
          grecaptcha.reset();
          loadingState(true);
        });
      return submitForm;
    } else {
      if (projectFormObj.formContainer) {
        projectFormObj.formContainer.classList.add(currentProjectStatus.img);
      }
      var statusHTML = "";

      (statusHTML +=
        '<h4 class="open-source-status__title">' +
        currentProjectStatus.heading +
        "</h4>"),
        (statusHTML +=
          '<span class="open-source-status__img ' +
          currentProjectStatus.img +
          '"></span>'),
        (statusHTML +=
          '<p class="open-source-status__message">' +
          currentProjectStatus.message +
          "</p>"),
        (statusHTML +=
          '<div class="input-wrapper open-source-status__cta"><a class="btn btn-primary" href="/users/sign_in">Go to your live dashboard</a></div>');
      if (projectFormObj.formContainer) {
        projectFormObj.formContainer.innerHTML = statusHTML;
      }
    }
  }
  function validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return pattern.test(str);
  }
  function validateFields() {
    var formValid = true,
      projectError = document.getElementById("project-error");
    //Required
    if (projectFormObj.projectUrlField.value.trim().length < 1) {
      formValid = _showError(
        projectFormObj.projectUrlField,
        projectError,
        "project-error",
        "Required"
      );
    } else if (!validURL(projectFormObj.projectUrlField.value.trim())) {
      formValid = _showError(
        projectFormObj.projectUrlField,
        projectError,
        "project-error",
        "Invalid"
      );
    } else {
      projectFormObj.projectUrlField.classList.remove("error-border");
      projectFormObj.projectUrlField.removeAttribute("aria-describedby");
      if (projectError) {
        projectError.remove();
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    if (fieldError) {
      fieldError.remove();
    }
    fieldName.classList.remove("error-border");
    fieldName.insertAdjacentHTML(
      "afterend",
      '<div class="error-message" id="' +
        errorName +
        '"><div class="msg-body"><span>' +
        errorMessage +
        "</span></div></div>"
    );
    fieldName.classList.add("error-border");
    fieldName.setAttribute("aria-describedby", errorName);
  }
})();

window.addEventListener("load", function () {
  projectForm.init();
});

var recaptchaCallback = function () {
  var forms = document.querySelector(".open-source__form");
  if (!forms) {
    return false;
  }
  if ("/users" == forms.getAttribute("action")) {
    return signUpForm.init(true);
  } else if (!projectForm.onLoadStatus) {
    return projectForm.saveProject(true);
  } else {
    return projectForm.setApplicationStatus();
  }
};
// //Reset captcha if expired
var expiredCaptchaCallback = function () {
  if (typeof grecaptcha !== "undefined") {
    grecaptcha.reset();
  }
};